import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { About, Home, Login } from "../public";

const Routes = () => {
  return (
    <React.Fragment>
      <Switch>
        <Route path="/about" component={About} />
        <Route path={`${process.env.PUBLIC_URL}`} component={Home} />
        <Route path={`${process.env.PUBLIC_URL}/`} component={Home} />
        <Route path={`${process.env.PUBLIC_URL}/login`} component={Login} />
        <Route path="/:unavailablePath">
          <Redirect to={process.env.PUBLIC_URL + "/"} />
        </Route>
        <Route path={process.env.PUBLIC_URL + "/"} component={Home} />
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
